import styled from 'styled-components';

const AvatarsContainer = styled.div`
  display: flex;
  width: auto;
  align-items: center;
  justify-content: space-between;
`;

export default AvatarsContainer;
